import styled from '@emotion/styled';
import { default as MUIDrawer } from '@mui/material/Drawer';

const Drawer = styled(MUIDrawer)`
  .MuiDrawer-paper {
    width: 606px;
  }
`;

export default {
  Drawer,
};
